import Panel from "@magicware/dashboard/Panel";
import { buildForm } from "@magicware/forms/builder";
import Form, { FormImplementationProps } from "@magicware/forms/components/Form";
import FormGrid from "@magicware/forms/components/FormGrid";
import FormTextField from "@magicware/forms/mui/FormTextField";
import { useTranslation } from "react-i18next";
import * as yup from "yup";
import { updateDetail } from "../../redux/connectorVersions/connectorVersionsReducer";
import { ConnectorVersionModelDetail, ConnectorVersionModelNew } from "../../services/api/connectorVersions";
import { FormDevicesAutocomplete } from "../devices/FormDevicesAutocomplete";
import { FormParametersAutocomplete } from "../parameters/FormParametersAutocomplete";

export const connectorVersionForm = buildForm<ConnectorVersionModelDetail>()(() => ({
    props: {
        remove: ["id", "version"],
        extra: [],
    },
    transformations: {
        toForm: { fromModel: (h, m: ConnectorVersionModelDetail) => h.fromModel(m) },
        formTo: {
            new: (h, f, connectorId: number): ConnectorVersionModelNew => ({
                ...h.toNewEntity(f),
                connectorId,
            }),
            update: (h, f, m: ConnectorVersionModelDetail) => h.toUpdateEntity(f, m),
        },
    },
    updateReduxModel: updateDetail,
    schema: (_, t) => ({
        name: yup.string().required(t("name-is-required")),
        parameterList: yup.array().default([]),
        deviceList: yup.array().default([]),
        notes: yup.string(),
    }),
}));

const f = connectorVersionForm.f;

export default function ConnectorVersionForm(props: FormImplementationProps<typeof f>) {
    const { t } = useTranslation();
    return (
        <Form validationSchema={connectorVersionForm.validationSchema} {...props}>
            <Panel>
                <FormGrid>
                    <FormTextField f={f} field="name" label={t("name-label")} autoFocus={props.autoFocus} />
                    <FormParametersAutocomplete
                        f={f}
                        field="parameterList"
                        fullOption
                        multiple
                        label={t("parameters-label")}
                        filter={{}}
                    />
                    <FormDevicesAutocomplete
                        f={f}
                        field="deviceList"
                        fullOption
                        multiple
                        label={t("devices-label")}
                        filter={{}}
                    />
                    <FormTextField f={f} field="notes" label={t("notes-label")} multiline />
                </FormGrid>
            </Panel>
        </Form>
    );
}
